import { getConfig } from "../../util/wagmiConfig"
import { createDrift, Drift } from "@delvtech/drift"
import { viemAdapter } from "@delvtech/drift-viem"
import { getPublicClient } from "@wagmi/core"
import { WalletClient } from "viem"

export function getDrift(chainId: number, walletClient?: WalletClient): Drift {
  const config = getConfig({ enableSSR: false })
  const publicClient = getPublicClient(config, { chainId })
  // @ts-ignore
  return createDrift({ adapter: viemAdapter({ publicClient, walletClient }) })
}
